import { faker } from '@faker-js/faker'

import { MedicalCase } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getMedicalCase = asBuilder((): MedicalCase => {
  return {
    beforePhoto: { url: faker.image.url() },
    afterPhoto: { url: faker.image.url() },
    daysAfter: faker.number.int(),
    description: faker.lorem.sentence(),
  }
})
